function generateFilterId() {
    return `filter_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
function getFieldById(fields, fieldId) {
    return fields.find((field)=>field.id === fieldId);
}
function isValidFilter(filter, field) {
    if (filter.fieldId !== field.id) return false;
    filter.operator;
    return true;
}
export { generateFilterId, getFieldById, isValidFilter };
